import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetMyChallengeInvitationDefaultGame } from "../../api-clients/gamesClient";

function useMyChallengeInvitationDefaultGameQuery() {
  const query = useQuery({
    queryKey: [QUERY_KEYS.GAME.MY_DEFAULT_GAME],
    queryFn: () => handleGetMyChallengeInvitationDefaultGame(),
  });

  return { query, gameId: query.data?.value };
}

export default useMyChallengeInvitationDefaultGameQuery;
